import styled from 'styled-components';
import { TitleMax2, InfoCardsWrapper } from '../../styles';

export const RelevanceWrapper = styled(InfoCardsWrapper)`
	grid-area: relevance;
	display: flex;
	flex-direction: column;
`;

export const RelevanceHeader = styled.div`
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	flex-wrap: wrap;
`;

export const RelevanceTitle = styled(TitleMax2)`
	display: flex;
	align-items: center;
`;

export const RelevanceDescription = styled.div`
	display: flex;
	${({ theme }) => theme.typography.textS};

	@media (max-width: 768px) {
		flex-wrap: wrap;
	}
	@media (max-width: 600px) {
		margin-top: 0;
	}
`;
